import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const SlideToggle = (props) => {
  const {
    checked,
    disabled,
    className,
    onValue,
    offValue,
    cursor,
    onChange,
    onLabel = '',
    offLabel = '',
    role,
  } = props;

  const toggleRef = useRef();
  const classes = cn([
    'slide_switch',
    checked && checked === onValue ? 'switch_on' : 'switch_off',
    cursor && cursor.value === onValue ? 'switch_on' : 'switch_off',
    className,
  ]);

  const toggle = (event) => {
    if (disabled) {
      return;
    }

    const { type, key } = event;
    if (type !== 'keydown' || key === ' ') {
      event.preventDefault();

      if (cursor) {
        cursor.requestChange(cursor.value === onValue ? offValue : onValue);
      }

      if (onChange) {
        onChange(props.checked === onValue ? offValue : onValue);
      }
    }
  };

  useEffect(() => {
    let eventHandler = toggle;

    if (disabled) {
      eventHandler = null;
    }

    toggleRef.current.onkeypress = eventHandler;
    toggleRef.current.onmousedown = eventHandler;
    toggleRef.current.ontouchstart = eventHandler;
  }, [checked, disabled]);

  // onTouchStart and onMouseDown are here because users tend to drag the icon, and we're taking a shortcut
  return (
    <div className={classes}>
      <div ref={toggleRef}>
        {offLabel && <span>{offLabel}</span>}
        <span className={cn('switch_outter', { disabled })}>
          <input
            type="checkbox"
            defaultChecked
            disabled={disabled}
            role={role}
            data-ft-id={props['data-ft-id']}
          />
          <span className="switch_toggle" />
        </span>
        {onLabel && <span>{onLabel}</span>}
      </div>
    </div>
  );
};

SlideToggle.propTypes = {
  cursor: PropTypes.object,
  onValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  offValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

SlideToggle.defaultProps = {
  cursor: null,
  onValue: true,
  offValue: false,
};

export default SlideToggle;
